import { useQuery } from "react-query";
import TrainingFeedbacksOverviewService from "./TrainingFeedbacksOverviewService";

const useTrainingFeedbacksOverview = () => {
  const { data: trainerResponse, isLoading: loadingTrainers } = useQuery(
    "feedbackByTrainers",
    TrainingFeedbacksOverviewService.getTopTrainerFeedbackAspects
  );

  const { data: traineeResponse, isLoading: loadingTrainees } = useQuery(
    "feedbackByTrainees",
    TrainingFeedbacksOverviewService.getTopTraineeFeedbackAspects
  );

  const { data: globalTraineeStatsResponse, isLoading: loadingStats } =
    useQuery(
      "globalTraineeStats",
      TrainingFeedbacksOverviewService.getGlobalTraineeFeedbackStats
    );

  const { data: globalTrainerStatsResponse, isLoading: loadingStatsTrainer } =
    useQuery(
      "globalTrainerStats",
      TrainingFeedbacksOverviewService.getGlobalTrainerFeedbackStats
    );

  const feedbackByTrainers = trainerResponse?.data ?? [];
  const feedbackByTrainees = traineeResponse?.data ?? [];

  const transformedTopFeedbackAspects = feedbackByTrainers.map((item) => ({
    aspect: item.aspect,
    average: parseFloat(item.average),
  }));

  const transformedTraineeTopFeedbackAspects = feedbackByTrainees.map(
    (item) => ({
      aspect: item.aspect,
      average: parseFloat(item.average),
    })
  );

  const feedbackData = [
    {
      name: "Positive",
      value: parseFloat(
        globalTraineeStatsResponse?.data?.levels?.positive?.percentage || "0"
      ),
    },
    {
      name: "Neutral",
      value: parseFloat(
        globalTraineeStatsResponse?.data?.levels?.neutral?.percentage || "0"
      ),
    },
    {
      name: "Negative",
      value: parseFloat(
        globalTraineeStatsResponse?.data?.levels?.negative?.percentage || "0"
      ),
    },
  ];
  const feedbackDataTrainer = [
    {
      name: "Positive",
      value: parseFloat(
        globalTrainerStatsResponse?.data?.levels?.positive?.percentage || "0"
      ),
    },
    {
      name: "Neutral",
      value: parseFloat(
        globalTrainerStatsResponse?.data?.levels?.neutral?.percentage || "0"
      ),
    },
    {
      name: "Negative",
      value: parseFloat(
        globalTrainerStatsResponse?.data?.levels?.negative?.percentage || "0"
      ),
    },
  ];
  return {
    transformedTopFeedbackAspects,
    transformedTraineeTopFeedbackAspects,
    feedbackData,
    globalTraineeFeedbackStats: globalTraineeStatsResponse?.data || {},
    loading: loadingTrainers || loadingTrainees || loadingStats,
    feedbackDataTrainer,
    globalTrainerFeedbackStats: globalTrainerStatsResponse?.data || {},
  };
};

export default useTrainingFeedbacksOverview;
